import {ActionList, CounterLabel} from '@primer/react'

import {LABELS} from '../../../constants/labels'
import {DependencyIssue, type DependencyIssueFragment} from './DependencyIssue'
import {LazyRelationshipsRelatesToListView} from './LazyRelationshipsRelatesToListView'
import type {RelatesToConnection, RelatesToIssueNode} from './relates-to-query-types'
import styles from './RelationshipsSection.module.css'
import {RelationshipsViewAllButton} from './RelationshipsViewAllButton'

export type RelatesToGroupProps = {
  topRelatesTo: RelatesToConnection
  owner: string
  repo: string
  issueNumber: number
  relatesToCount: number
  showDivider: boolean
  onLinkClick?: (event: MouseEvent) => void
}

export function RelatesToGroup({
  topRelatesTo,
  owner,
  repo,
  issueNumber,
  relatesToCount,
  showDivider,
  onLinkClick,
}: RelatesToGroupProps) {
  const topNodes = (topRelatesTo.nodes ?? []).filter((node): node is RelatesToIssueNode => !!node)
  return (
    <>
      {showDivider && <ActionList.Divider className={styles.ActionList_Divider} />}
      <ActionList.Group>
        <ActionList.GroupHeading as="h4" className={styles.ActionList_GroupHeading}>
          {LABELS.relationNames.relatesToIssues}
          {relatesToCount > 0 && (
            <CounterLabel className={styles.RelationshipCountLabel} variant="secondary" data-testid="relates-to-count">
              {relatesToCount}
            </CounterLabel>
          )}
        </ActionList.GroupHeading>
        {topNodes.map(relatedIssue => (
          // RELAY-CLEANUP(RelationshipsSectionQuery): `RelayCompat` widens nested fields to `| undefined`, so the
          // node isn't directly assignable to the plain `DependencyIssueFragment`. Remove once this leaves Relay.
          <DependencyIssue
            key={relatedIssue.id ?? `${relatedIssue.repository.nameWithOwner}#${relatedIssue.number}`}
            onLinkClick={onLinkClick}
            issue={relatedIssue as DependencyIssueFragment}
          />
        ))}
        {topRelatesTo.pageInfo?.hasNextPage && (
          <RelationshipsViewAllButton
            key="relates-to-view-all"
            dialogTitle={LABELS.relationNames.relatesToIssues}
            count={relatesToCount}
          >
            <LazyRelationshipsRelatesToListView owner={owner} repo={repo} issueNumber={issueNumber} />
          </RelationshipsViewAllButton>
        )}
      </ActionList.Group>
    </>
  )
}
